(function () {
  const registry = new Map();
  const instances = new WeakMap();

  function register(name, definition) {
    if (!name || !definition || typeof definition.init !== 'function') return;
    registry.set(name, definition);
  }

  function init(root) {
    const scope = root || document;
    const components = scope.matches?.('[data-component]')
      ? [scope]
      : Array.from(scope.querySelectorAll('[data-component]'));

    components.forEach((element) => {
      const name = element.getAttribute('data-component');
      const definition = registry.get(name);
      if (!definition || instances.has(element)) return;
      const cleanup = definition.init(element) || null;
      instances.set(element, { name, cleanup });
      element.setAttribute('data-component-initialized', 'true');
    });
  }

  function destroy(root) {
    const scope = root || document;
    const components = scope.matches?.('[data-component]')
      ? [scope]
      : Array.from(scope.querySelectorAll('[data-component]'));

    components.forEach((element) => {
      const instance = instances.get(element);
      if (!instance) return;
      if (typeof instance.cleanup === 'function') instance.cleanup(element);
      instances.delete(element);
      element.removeAttribute('data-component-initialized');
    });
  }

  window.RotaTheme = {
    register,
    init,
    destroy,
  };
})();
